import { OPERATIONS, SECTIONS } from "../../../../config/constants";
import PageHead from "../../../layout/PageHead";
import { Button, Dropdown, Menu, Tabs } from "antd";
import "./MigrationRules.css";
import { useSearchParams } from "react-router-dom";
import RuleOverview from "./components/RuleOverview";
import RuleValues from "./components/RuleValues";
import RuleConditions from "./components/RuleConditions";
import RuleResults from "./components/RuleResults";
import { useEffect, useState } from "react";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../services/tables/TablesService";
import {
  DeleteRowOutlined,
  DownOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import NewRuleOverview from "./components/components/NewRuleOverview";
import CopyRuleOverview from "./components/components/CopyRuleOverview";
import { useTranslation } from "react-i18next";
import {ROUTES} from "../../../../config/consts/routes";

const { TabPane } = Tabs;

const routes = [
  {
    path: ROUTES.general.main.name,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.operation.name,
  },
  {
    path: ROUTES.operation.migrationRules.route,
    breadcrumbName: ROUTES.operation.migrationRules.name,
  },
];

const MigrationRules = () => {
  const { t, i18n } = useTranslation("translations");
  const [searchParams, setSearchParams] = useSearchParams();
  const [previousTab, setPreviousTab] = useState<any>(undefined);

  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();
  const [newConditionModalEnabled, setNewConditionModalEnabled] =
    useState(false);
  const [newRuleOverviewModalEnabled, setNewRuleOverviewModalEnabled] =
    useState(false);
  const [newRuleValueModalEnabled, setNewRuleValueModalEnabled] =
    useState(false);

  const [newRuleOverviewDialogMode, setNewRuleOverviewDialogMode] =
    useState(false);
  const [copyRuleOverviewDialogMode, setCopyRuleOverviewDialogMode] =
    useState(false);

  const [triggerUpdate, setTriggerUpdate] = useState<boolean>(false);

  const [isNewRuleFormDirty, setIsNewRuleFormDirty] = useState<boolean>(false);
  const [newRuleFormPopConfirmOpen, setNewRuleFormPopConfirmOpen] = useState<boolean>(false);

  useEffect(() => {
    document.title = ROUTES.operation.migrationRules.name;
  }, []);

  useEffect(() => {
    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });
    TablesService.getAllEntities().then((response: any) => {
      const data = response.data;
      setEntities(data);
    });
    TablesService.getAllOperations().then((response: any) => {
      const data = response.data;
      setOperations(data);
    });
  }, []);

  useEffect(() => {
    if (operations) {
      setSelectedOperation(OPERATIONS.LEGACY)
    }
  }, [operations]);

  useEffect(() => {
    if (isNewRuleFormDirty) {
      handleNewRuleFormPopConfirmOpen(true);
    } else {
      setNewRuleOverviewDialogMode(false);
      setIsNewRuleFormDirty(false);
    }
  }, [searchParams]);

  const onChange = (key: string) => {
    searchParams.set("tab", key);
    setSearchParams(searchParams);
  };

  const handleNewConditionButtonClick = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    setNewConditionModalEnabled(true);
  };

  const handleNewRuleOverviewButtonClick = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    // setNewRuleOverviewModalEnabled(true);
    setNewRuleOverviewDialogMode(true);
  };

  const handleNewRuleValueButtonClick = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    setNewRuleValueModalEnabled(true);
  };

  const handleCopyRuleOverviewButtonClick = () => {
    setCopyRuleOverviewDialogMode(true);
  };

  const handleNewRuleFormPopConfirmOpen = (newOpen: boolean) => {
    if (!newOpen) {
      setNewRuleFormPopConfirmOpen(newOpen);
      return;
    }
    if (!isNewRuleFormDirty) {
      setNewRuleOverviewDialogMode(false);
      setIsNewRuleFormDirty(false);
    } else {
      setNewRuleFormPopConfirmOpen(newOpen);
    }
  }

  const dropdownMenu = (
    <Menu
      className="twoFoldMenu"
      style={{ padding: "10px" }}
      selectable
      onClick={() => handleCopyRuleOverviewButtonClick()}
      items={
        [
          // {
          //   label: t(
          //     "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.ActionCopyMappings",
          //     {
          //       lngs: i18n.languages,
          //       defaultValue: "Copy mappings",
          //     }
          //   ),
          //   key: "1",
          //   // icon: <FlagOutlined />,
          // },
        ]
      }
    />
  );

  const ruleConditionActionButton = (
    <Button
      type={"primary"}
      onClick={handleNewConditionButtonClick}
      className="actionButton"
    >
      <PlusOutlined />
      {t(
        "Page.Operation.MigrationRules.Tabs.RuleConditions.Labels.ActionNewCondition",
        {
          lngs: i18n.languages,
          defaultValue: "NEW CONDITION",
        }
      )}
    </Button>
  );

  const ruleOverviewActionButton = (
    <Button
      type={"primary"}
      onClick={handleNewRuleOverviewButtonClick}
      className="actionButton"
    >
      <PlusOutlined />
      {t(
        "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.ActionNewRule",
        {
          lngs: i18n.languages,
          defaultValue: "NEW RULE",
        }
      )}
    </Button>
  );

  const ruleValuesActionButton = (
    <Button
      disabled={!selectedEntity}
      type={"primary"}
      onClick={handleNewRuleValueButtonClick}
      className="actionButton"
    >
      <PlusOutlined />
      {t("Page.Operation.MigrationRules.Tabs.RuleValues.Labels.ActionNewRule", {
        lngs: i18n.languages,
        defaultValue: "NEW RULE",
      })}
    </Button>
  );

  return (
    <div>
      <PageHead
        title={ROUTES.operation.migrationRules.name}
        icon={<DeleteRowOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={operations}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={selectedOperation}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setSelectedOperation}
        setSelectGroupCodeDisabled={
          searchParams.get("tab")
            ? searchParams.get("tab") === "rule-overview"
              ? false
              : searchParams.get("tab") === "rule-conditions"
              ? true
              : searchParams.get("tab") === "rule-values"
              ? true
              : searchParams.get("tab") === "rule-results"
              ? false
              : false
            : false
        }
        setSelectEntityDisabled={
          searchParams.get("tab")
            ? searchParams.get("tab") === "rule-overview"
              ? false
              : searchParams.get("tab") === "rule-conditions"
              ? true
              : searchParams.get("tab") === "rule-values"
              ? false
              : searchParams.get("tab") === "rule-results"
              ? false
              : false
            : false
        }
        setSelectOperationDisabled={
          searchParams.get("tab")
            ? searchParams.get("tab") === "rule-overview"
              ? true
              : searchParams.get("tab") === "rule-conditions"
              ? true
              : searchParams.get("tab") === "rule-values"
              ? true
              : searchParams.get("tab") === "rule-results"
              ? true
              : true
            : true
        }
        mainAction={
          searchParams.get("tab")
            ? searchParams.get("tab") === "rule-overview"
              ? ruleOverviewActionButton
              : searchParams.get("tab") === "rule-conditions"
              ? ruleConditionActionButton
              : searchParams.get("tab") === "rule-values"
              ? ruleValuesActionButton
              : searchParams.get("tab") === "rule-results"
              ? null
              : null
            : null
        }
        otherActions={[]}
        setActionsDisabled={false}
      />
      <div className="card-container">
        {newRuleOverviewDialogMode && (
          <>
            <NewRuleOverview
              entities={entities}
              selectedEntity={selectedEntity}
              selectedGroupCode={selectedGroupCode}
              isDirty={isNewRuleFormDirty}
              popConfirmOpen={newRuleFormPopConfirmOpen}
              newRuleOverviewDialogMode={newRuleOverviewDialogMode}
              setNewRuleOverviewDialogMode={setNewRuleOverviewDialogMode}
              setTriggerUpdate={setTriggerUpdate}
              setIsDirty={setIsNewRuleFormDirty}
              handlePopConfirmOpen={handleNewRuleFormPopConfirmOpen}
            />
          </>
        )}
        {copyRuleOverviewDialogMode && (
          <>
            <CopyRuleOverview
              selectedEntity={selectedEntity}
              selectedGroupCode={selectedGroupCode}
              copyRuleOverviewDialogMode={copyRuleOverviewDialogMode}
              setCopyRuleOverviewDialogMode={setCopyRuleOverviewDialogMode}
              setTriggerUpdate={setTriggerUpdate}
            />
          </>
        )}
        {!copyRuleOverviewDialogMode && !newRuleOverviewDialogMode && (
          <Tabs
            type="card"
            activeKey={searchParams.get("tab") ? searchParams.get("tab")! : ""}
            onTabClick={onChange}
            style={{ height: "100%" }}
          >
            <TabPane
              tab={t("Page.Operation.MigrationRules.Tabs.RuleOverview", {
                lngs: i18n.languages,
                defaultValue: "Rule Overview",
              })}
              key="rule-overview"
            >
              <RuleOverview
                selectedEntity={selectedEntity}
                selectedGroupCode={selectedGroupCode}
                newRuleOverviewModalEnabled={newRuleOverviewModalEnabled}
                setNewRuleOverviewModalEnabled={setNewRuleOverviewModalEnabled}
                triggerUpdate={triggerUpdate}
                setTriggerUpdate={setTriggerUpdate}
                entities={entities}
              />
            </TabPane>
            <TabPane
              tab={t("Page.Operation.MigrationRules.Tabs.RuleValues", {
                lngs: i18n.languages,
                defaultValue: "Rule Values",
              })}
              key="rule-values"
            >
              <RuleValues
                entities={entities}
                selectedEntity={selectedEntity}
                newRuleValueModalEnabled={newRuleValueModalEnabled}
                setNewRuleValueModalEnabled={setNewRuleValueModalEnabled}
                selectable={false}
                multiSelect={false}
                selectedRows={[]}
                setSelectedRows={undefined}
              />
            </TabPane>
            <TabPane
              tab={t("Page.Operation.MigrationRules.Tabs.RuleConditions", {
                lngs: i18n.languages,
                defaultValue: "Rule Conditions",
              })}
              key="rule-conditions"
            >
              <RuleConditions
                newConditionModalEnabled={newConditionModalEnabled}
                setNewConditionModalEnabled={setNewConditionModalEnabled}
                selectable={false}
                multiSelect={false}
                selectedRows={[]}
                setSelectedRows={undefined}
              />
            </TabPane>
            <TabPane
              className={"rule-results"}
              tab={t("Page.Operation.MigrationRules.Tabs.RuleResults", {
                lngs: i18n.languages,
                defaultValue: "Rule Results",
              })}
              key="rule-results"
            >
              <RuleResults
                selectedEntity={selectedEntity}
                selectedGroupCode={selectedGroupCode}
                selectable={false}
                multiSelect={false}
                selectedRows={[]}
                setSelectedRows={undefined}
              />
            </TabPane>
          </Tabs>
        )}
      </div>
    </div>
  );
};

export default MigrationRules;
